/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ApplicationCreateStatus {
  AgreeToRisky = 'AGREE_TO_RISKY',
  Moderation = 'MODERATION',
  CheckPayment = 'CHECK_PAYMENT',
  FullCheck = 'FULL_CHECK',
  FullCheckLow = 'FULL_CHECK_LOW',
  FullCheckMedium = 'FULL_CHECK_MEDIUM',
  FullCheckHigh = 'FULL_CHECK_HIGH',
}

export function instanceOfApplicationCreateStatus(value: any): boolean {
  for (const key in ApplicationCreateStatus) {
    if (Object.prototype.hasOwnProperty.call(ApplicationCreateStatus, key)) {
      if (
        ApplicationCreateStatus[key as keyof typeof ApplicationCreateStatus] ===
        value
      ) {
        return true
      }
    }
  }
  return false
}

export function ApplicationCreateStatusFromJSON(
  json: any
): ApplicationCreateStatus {
  return ApplicationCreateStatusFromJSONTyped(json, false)
}

export function ApplicationCreateStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationCreateStatus {
  return json as ApplicationCreateStatus
}

export function ApplicationCreateStatusToJSON(
  value?: ApplicationCreateStatus | null
): any {
  return value as any
}
